export default __webpack_public_path__ + "static/media/unauthorized.15bfca05.svg";